// extracted by mini-css-extract-plugin
export default {"icons":"hand-care_icons__lxSib","icon":"hand-care_icon__bch1S","hyphens":"hand-care_hyphens__VBqGT","imgWrapper":"hand-care_imgWrapper__eEe5s","iconText":"hand-care_iconText__Nv+fh"};